/* Chain of Custody timeline dots. The vertical position (top) is measured per
   event row at runtime and set inline by the component; everything else lives
   here. All colours are theme tokens so the dots follow dark mode. */
.dot {
  position: absolute;
  left: -24px;
  transform: translateY(-50%);
}

.file {
  left: -12px;
  background-color: var(--surface-container);
}

.awb {
  left: -16px;
  display: block;
  width: 20px;
  height: 20px;
  background-color: var(--surface-container);
}

.customs {
  left: -13px;
  display: block;
  padding-bottom: 6px;
  background-color: var(--surface-container);
}

.plain {
  left: -11px;
}

.circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: var(--gray-600);
}

.danger {
  background-color: var(--danger);
}

.glyph {
  font-size: 16px;
  color: white;
}

.gxp {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 16px;
  background-color: var(--surface-container);
}

.awbIcon {
  display: block;
  width: 20px;
  height: 20px;
  object-fit: fill;
}

.globe {
  font-size: 14px;
  color: var(--text-primary);
}

.defaultDot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: var(--text-primary);
}
